module.exports = __webpack_public_path__ + "img/bd.cff9ae3b.svg";